import { render, staticRenderFns } from "./income-statment-detail.vue?vue&type=template&id=0b49b8a5&"
import script from "./income-statment-detail.vue?vue&type=script&lang=js&"
export * from "./income-statment-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports